import { handleActions } from 'redux-actions';
import { setSelectedPassengerId } from './actions';
const initialState = 0;
const selectedPassengerIdReducer = handleActions({
    [setSelectedPassengerId.toString()]: (_, { payload }) => payload
}, initialState);
export default selectedPassengerIdReducer;
